export function ContactSkeleton() {
  return (
    <div class="space-y-1 animate-pulse" aria-hidden="true" role="status" aria-label="Carregando contatos...">
      {[1, 2, 3, 4, 5, 6].map(i => (
        <div
          key={i}
          class="contact-card relative z-10 select-none opacity-70 border border-slate-800/40 bg-slate-900/30"
        >
          <div class="flex items-center gap-3 min-w-0 flex-1">
            {/* Avatar Skeleton */}
            <div class="w-10 h-10 rounded-full bg-slate-800/90 flex-shrink-0" />

            {/* Info Lines Skeleton */}
            <div class="min-w-0 flex-1 space-y-2 py-0.5">
              <div class="flex items-center justify-between gap-2">
                <div class="h-3.5 bg-slate-800/90 rounded-md w-28" />
                <div class="h-2.5 bg-slate-800/60 rounded-md w-10" />
              </div>
              <div class="h-2.5 bg-slate-800/50 rounded-md w-4/5" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
